import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { t, LANGUAGES } from '../utils/localization/localization';
import { useLanguageAwareRender } from '../hooks/useLanguageAwareRender';
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

/**
 * Test page to debug translation issues
 */
function TranslationTestPage() {
  const { currentLanguage, toggleLanguage } = useLanguage();

  // Use standardized language-aware render hook
  const renderKey = useLanguageAwareRender('TranslationTestPage');

  // Test translations
  const testTranslations = {
    'cvAnalyzer.uploadStep': t('cvAnalyzer.uploadStep'),
    'cvAnalyzer.reviewStep': t('cvAnalyzer.reviewStep'),
    'jobAnalyzer.uploadStep': t('jobAnalyzer.uploadStep'),
    'jobAnalyzer.reviewStep': t('jobAnalyzer.reviewStep'),
    'jobAnalyzer.skillsAnalysisResults': t('jobAnalyzer.skillsAnalysisResults'),
    'jobAnalyzer.skillColumn': t('jobAnalyzer.skillColumn'),
    'jobAnalyzer.categoryColumn': t('jobAnalyzer.categoryColumn'),
    'jobAnalyzer.importanceColumn': t('jobAnalyzer.importanceColumn'),
    'jobAnalyzer.contextColumn': t('jobAnalyzer.contextColumn')
  };

  return (
    <Container maxWidth="md" key={renderKey}>
      <Box sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" gutterBottom align="center">
            Translation Test Page
          </Typography>

          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={toggleLanguage}
              sx={{ mb: 2 }}
            >
              {currentLanguage === LANGUAGES.EN ? 'Switch to French' : 'Switch to English'}
            </Button>
          </Box>

          <Typography variant="h6">
            Current Language: {currentLanguage === LANGUAGES.EN ? 'English' : 'French'}
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h6" gutterBottom>
            Test Translations:
          </Typography>

          <List>
            {Object.entries(testTranslations).map(([key, value]) => (
              <ListItem key={key} divider>
                <ListItemText
                  primary={key}
                  secondary={value}
                  primaryTypographyProps={{ fontWeight: 'bold' }}
                  secondaryTypographyProps={{ color: 'primary' }}
                />
              </ListItem>
            ))}
          </List>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body1" paragraph>
            If you see translation keys (like "jobAnalyzer.skillsAnalysisResults") instead of
            actual translations, it means there's an issue with the translation system.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
}

export default TranslationTestPage;
